// Angular dependencies
import '@angular/common';
import '@angular/core';
import '@angular/forms';
import '@angular/http';
import '@angular/animations';
import 'rxjs';

// Own dependencies
import 'ngx-bootstrap';
